import { Accordion, AccordionSummary, styled } from '@mui/material';

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    '&.Mui-expanded .MuiSvgIcon-root': {
        color: theme.palette.secondary.main,
    },
    '&.Mui-expanded .MuiTypography-root': {
        fontWeight: 600,
        transform: 'translateX(10px) scaleX(0.98)',
        transition: 'transform 0.3s ease, font-weight 0.3s ease',
    },
    '&:hover .MuiSvgIcon-root': { color: theme.palette.secondary.main },
    '&:hover .MuiTypography-root': {
        fontWeight: 600,
        transform: 'translateX(10px) scaleX(1.08)',
        transition: 'transform 0.3s ease, font-weight 0.3s ease',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    '.MuiTypography-root': {
        transition: 'transform 0.3s ease, font-weight 0.3s ease',
    },
    gap: '1rem',
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
    '::before': { display: 'none' },
    backgroundColor: 'white',
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: '0px',
    boxShadow: 'none',
    marginTop: '1rem',
}));

export const StyledBoxAccordion = styled(Accordion)(({ theme }) => ({
    '::before': { display: 'none' },
    alignItems: 'center',
    background: 'transparent',
    border: '1px solid',
    borderColor: theme.palette.grey[100],
    justifyContent: 'space-between',
    padding: '0.5rem',
}));
